import type {
  PatientCreditTransfer,
  TransferPatientCreditRequest,
} from "@/types/billing/patient-credit-transfer";

import { requestData } from "@/api/api-config";

export async function transferPatientCredit(
  sourceCreditId: string,
  body: TransferPatientCreditRequest,
): Promise<PatientCreditTransfer | null> {
  // catchError=false → HTTP errors (4xx/5xx) throw so the caller can surface
  // the actual reason (stale balance, missing permission, etc.) instead of
  // resolving as null and silently closing the dialog.
  return await requestData<PatientCreditTransfer>(
    `user/patient/credit/${sourceCreditId}/transfer`,
    "post",
    {
      json: {
        to_patient_id: body.toPatientId,
        amount: body.amount,
        reason: body.reason,
        note: body.note,
      },
    },
    false,
  );
}

export async function listPatientCreditTransfers(
  patientId: string,
): Promise<PatientCreditTransfer[] | null> {
  return await requestData<PatientCreditTransfer[]>(
    `user/patient/${patientId}/credit-transfers`,
    "get",
  );
}
